const importData = function importData(data, imgNode) {
	const r = imgNode.height / imgNode.width;

	const baseWidth = Number(data.base_width);
	const baseHeight = Number(data.base_height);

	const rotation = Number(data.I_Rotation) || 0;
	const width = Number(data.I_Sollbreite) || baseWidth || 500;
	const height = Number(data.I_Sollhoehe) || baseHeight || 500;

	const background = (data.S_Background === 'transparent' && data.S_Background) ||
	                   (data.S_Background &&
	                    !isNaN(parseInt(data.S_Background, 16)) &&
	                    `#${data.S_Background}`) || (!data.S_Background && 'transparent');
	const scale = (baseWidth && Number(data.I_Sollbreite) &&
			      Number(data.I_Breite) / Number(data.I_Sollbreite)) || 1;
	const top = (data.I_Oben && data.I_Breite && data.I_Sollhoehe &&
			     ((Number(data.I_Oben) + ((Number(data.I_Breite) / 2) * r)) /
			     Number(data.I_Sollhoehe)) - (1 / 2)) || 0;
	const left = (data.I_Links && data.I_Breite && data.I_Sollbreite &&
			      ((Number(data.I_Links) + (Number(data.I_Breite) / 2)) /
			      Number(data.I_Sollbreite)) - (1 / 2)) || 0;
	const border = data.B_Rahmen === 'j';


	return {
		rotation,
		width,
		height,
		background,
		scale,
		top,
		left,
		border,
	};
};

const exportData = function exportData(data, imgNode) {
	const r = imgNode.height / imgNode.width;

	return {
		I_Rotation: data.rotation,
		I_Sollbreite: data.width,
		I_Sollhoehe: data.height,
		S_Background: data.background && data.background.replace('#', ''),
		I_Breite: data.width && data.scale &&
			data.width * data.scale,
		I_Oben: data.height && data.width && data.scale &&
			(data.height * (0.5 + data.top)) - (data.width * (data.scale / 2) * r),
		I_Links: data.width && data.width && data.scale &&
			(data.width * (0.5 + data.left)) - (data.width * (data.scale / 2)),
	};
};

export default { importData, exportData };



// WEBPACK FOOTER //
// ./src/helper/convertHelper.js